import { type PortableTextComponentProps } from '@portabletext/react'
import cx from 'classnames'

import { HasFontCase, SanityButtonStyle } from '@data/sanity/queries/types/link'
import { SanityVideo } from '@data/sanity/queries/types/video'
import { SanityImageFragment } from '@data/sanity/queries/types/image'

import BaseVideoButton from '@components/buttons/video-button'
import {
  getButtonColor,
  getButtonIconAlignment,
  getButtonSize,
  getButtonVariant,
} from '@components/buttons/button'

type VideoButtonValue = HasFontCase & {
  id?: string
  text?: string
  style: SanityButtonStyle
  video: SanityVideo
  thumbnail?: SanityImageFragment
}

const VideoButton = ({
  value,
}: PortableTextComponentProps<VideoButtonValue>) => {
  const {
    id,
    text,
    video,
    thumbnail,
    fontCase,
    style: { variant, size, color, icon, iconAlignment, isFullWidth },
  } = value

  return (
    <BaseVideoButton
      id={id}
      video={video}
      thumbnail={thumbnail}
      variant={getButtonVariant(variant)}
      size={getButtonSize(size)}
      color={getButtonColor(color)}
      icon={icon}
      iconAlignment={getButtonIconAlignment(iconAlignment)}
      className={cx(
        'btn',
        {
          'w-full': isFullWidth,
        },
        fontCase ?? '',
      )}
    >
      {text}
    </BaseVideoButton>
  )
}

export default VideoButton
